import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Landing() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="landing-page">
      {/* Hero */}
      <section className="landing-hero">
        <div className="landing-hero-badge">Calorie Tracking Made Simple</div>
        <h1 className="landing-title">
          Calorie<span className="landing-title-accent">Track</span>™
        </h1>
        <p className="landing-subtitle">
          Simple calorie counting. Track what you eat, reach your goals.
        </p>
        <div className="landing-cta">
          <Link to="/register" className="btn btn-primary btn-lg landing-cta-btn">
            Get Started Free
          </Link>
        </div>
        <p className="landing-signin">
          Already have an account?{' '}
          <Link to="/login" className="auth-link">Log in</Link>
        </p>
      </section>

      {/* Features */}
      <section className="landing-features">
        <div className="feature-card">
          <div className="feature-icon-wrap">
            <span className="feature-icon-char">&#x1F50D;</span>
          </div>
          <h3 className="feature-title">Search Any Food</h3>
          <p className="feature-desc">
            Look up calories and nutrition info for thousands of foods from the USDA database.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-icon-wrap">
            <span className="feature-icon-char">&#x1F4CA;</span>
          </div>
          <h3 className="feature-title">Track Your Day</h3>
          <p className="feature-desc">
            Log meals and see your daily calorie total at a glance. Quick, simple, no clutter.
          </p>
        </div>

        <div className="feature-card">
          <div className="feature-icon-wrap">
            <span className="feature-icon-char">&#x1F3AF;</span>
          </div>
          <h3 className="feature-title">Reach Your Goals</h3>
          <p className="feature-desc">
            Set calorie goals and track your progress over time with visual history.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <span className="landing-footer-name">CalorieTrack™</span>
        <span className="landing-footer-dot">&middot;</span>
        <span className="landing-footer-text">Eat well. Live better.</span>
      </footer>
    </div>
  );
}

export default Landing;
